import { faArrowRight, faCheck, faFilePdf, faFileExcel, faFile, faCancel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextField } from '@mui/material';
import axios from 'axios';
import { Buffer } from 'buffer';
import useAuthz from 'hooks/useAuthz';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useAlert } from 'react-alert';
import { IMaskInput } from 'react-imask';
import { useNavigate } from 'react-router';
import ElemPatriActionRenderer from '../../components/AgGrid/ElemPatriActionRenderer';
import StepCaractConvoi from '../../components/Dossier/Steps/StepCaractConvoi';
import StepControleRef from '../../components/Dossier/Steps/StepControleRef';
import StepDatePassage from '../../components/Dossier/Steps/StepDatePassage';
import StepDocuments from '../../components/Dossier/Steps/StepDocuments';
import StepEngagementValidationContrat from '../../components/Dossier/Steps/StepEngagementValidationContrat';
import StepIdentiteMandataireEtTransporteur from '../../components/Dossier/Steps/StepIdentiteMandataireEtTransporteur';
import StepTrajetDescr from '../../components/Dossier/Steps/StepTrajetDescr';
import MyButton from '../../components/Layout/MyButton';
import MyDialog from '../../components/Layout/MyDialog';
import MyModal from '../../components/Layout/MyModal';
import MySelect from '../../components/Layout/MySelect';
import ActionsRequestPassRenderer from '../../components/AgGrid/ActionsRequestPassRenderer';
import {
    CLIENT_TYPE,
    DOCUMENT_TYPE,
    IDENTITY_AGENT_TYPE, PARAMETER,
    PROFIL,
    REQUEST_PASS_STATUS,
    REQUEST_PASS_TYPE, TRJT_TYPE,
} from '../../constants/enum';
import { URL_API } from '../../utils/globalConfig';
import { StepInformationsComplementaires } from '../../components/Dossier/Steps/StepInformationsComplementaires';
import { StepValidationIntervenants } from '../../components/Dossier/Steps/StepValidationIntervenants';
import { StepTchat } from '../../components/Dossier/Steps/StepTchat';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearCaracConvoi,
    clearInfosCompl,
    clearReference, clearTrajetDescr,
    loadCaracConvoi, loadInfosCompl,
    loadReference, loadTrajetDescr, updateTrajetDescr,
} from '../../actions/RequestPassAction';
import { logError } from '../../components/Utils/FormatData';

const demandePassageStyle = {
    textField: { width: '50%', margin: '20px' },
    textFieldShort: { width: '25%', margin: '20px' },
    textFieldFixed: { maxWidth: '200px', margin: '20px' },
    rowIntoPaper: { maxHeight: '100px', alignItems: 'center' },
    sectionPaper: { width: 'calc(100% - 20px)', padding: '0 0 40px 20px', margin: '15px' },
    sectionLibelle: { padding: '15px', textTransform: 'uppercase', fontFamily: 'Gadugi' },
    listItem: { marginBottom: '10px', fontSize: '16px' },
};
const adminEntries = [
    { name: 'infos_gen', description: 'Informations générales' },
    { name: 'identite_mandataire', description: 'Identification du mandataire / pétitionnaire / Tiers facturé' },
    { name: 'caract_convoi', description: 'Caractéristiques du convoi' },
    { name: 'trajet_descr', description: 'Description du trajet / Éléments patrimoine' },
    { name: 'date_passage', description: 'Date de passage / Durée d\'autorisation' },
    { name: 'documents', description: 'Import des documents' },
    { name: 'engagement_et_validation_contrat', description: 'Engagement' },
    { name: 'informations_complementaires', description: 'Informations complementaires' },
    { name: 'validation_des_intervenants', description: 'Validation des intervenants' },
];

const clientEntries = [
    { name: 'infos_gen', description: 'Informations générales' },
    { name: 'identite_mandataire', description: 'Identification du mandataire / pétitionnaire / Tiers facturé' },
    { name: 'caract_convoi', description: 'Caractéristiques du convoi' },
    { name: 'trajet_descr', description: 'Description du trajet / Éléments patrimoine' },
    { name: 'date_passage', description: 'Date de passage / Durée d\'autorisation' },
    { name: 'documents', description: 'Import des documents' },
    { name: 'engagement_et_validation_contrat', description: 'Engagement' },
];

const PhoneMask = React.forwardRef(function PhoneMask(props, ref) {
    const { onChange, ...other } = props;
    return (<IMaskInput
        {...other}
        mask='+{#00} 00 00 00 00'
        definitions={{
            '#': /[1-9]/,
        }}
        inputRef={ref}
        onAccept={(value) => onChange({ target: { name: props.name, value } })}
        autoComplete='off'
        overwrite
    />);
});

const DemandePassage = (props) => {
    const duplicateRequestPassId = new URLSearchParams(location.search).get('duplicate') || 0;
    const requestPassId = new URLSearchParams(location.search).get('id') || 0;
    const dispatch = useDispatch();
    const refs = useRef([]);
    const alert = useAlert();
    const navigate = useNavigate();
    const frameworkComponents = {
        'elemPatriActionRenderer': ElemPatriActionRenderer,
    };
    const [authz, user, profil] = useAuthz();
    const [overlayLoading, setOverlayLoading] = useState(false);
    const [numberActiveStep, setNumberActiveStep] = useState(0);
    const [blacklistedUsersList, setBlacklistedUsersList] = useState([]);
    const [blacklisted, setBlacklisted] = useState(false);
    const [notAbleToChange, setNotAbleToChange] = useState(true);
    const [dossier, setDossier] = useState([]);
    const [demandePassage, setDemandePassage] = useState({ id: requestPassId, id_status: REQUEST_PASS_STATUS.NEW, planifications: [] });
    const [dataFetched, setDataFetched] = useState(false);
    const [isBuilding, setBuilding] = useState(true);
    const reference = useSelector((state) => state['RequestPass'].reference);
    const caracConvoi = useSelector((state) => state['RequestPass'].caracConvoi);
    const [complementIdentite, setComplementIdentite] = useState({
        value: null,
        military: 'false',
        transporteur: null,
        adresse: null,
        complementAdresse: null,
        codePostal: null,
        commune: null,
        pays: null,
        email: null,
        telephone1: null,
        telephone2: null,
        fax: null,
        numSiren: null,
        numTva: null,
        mandataire: {
            transporteur: null,
            adresse: null,
            complementAdresse: null,
            codePostal: null,
            commune: null,
            pays: null,
            email: null,
            telephone1: null,
            telephone2: null,
            fax: null,
            numSiren: null,
            numTva: null,
        },
        tiers: {
            transporteur: null,
            email: null,
            telephone1: null,
            telephone2: null,
            fax: null,
            numSiren: null,
            numTva: null,
            numSap: null,
            numSapSubsidiary: null,
        },
    });
    const [representative, setRepresentative] = useState({
        transporteur: null,
        adresse: null,
        complementAdresse: null,
        codePostal: null,
        commune: null,
        pays: null,
        email: null,
        telephone1: null,
        telephone2: null,
        fax: null,
        numSiren: null,
        numTva: null,
    });
    const [thirdParty, setThirdParty] = useState({
        value: CLIENT_TYPE.TIER,
        transporteur: null,
        email: null,
        telephone1: null,
        telephone2: null,
        numSiren: null,
        numTva: null,
        numSap: null,
        numSapSubsidiary: null,
    });
    const trajetDescr = useSelector((state) => state['RequestPass'].trajetDescr);
    const [datePassage, setDatePassage] = useState({
        startDate: null, endDate: null,
        duration: null,
        nbPassageAller: null,
        nbVehiculeAller: null,
        nbPassageRetour: null,
        nbVehiculeRetour: null,
    });
    const [tracingDossier, setTracingDossier] = useState({
        sendDate: null,
        returnDate: null,
        receptionDate: null,
        pickUpDate: null,
        transporterAnswerDate: null,
        billSendDate: null,
        billAmount: null,
        blackList: false,
        description: null,
        readAndSignedBy: null,
        alert: false,
    });
    const [documents, setDocuments] = useState({
        files: [], initialFiles: null,
    });
    const [adminDocuments, setAdminDocuments] = useState({
        files: [], initialFiles: null,
    });
    const complInfo = useSelector((state) => state['RequestPass'].complInfo);
    const [validationSaisies, setValidationSaisies] = useState({
        steDevis: false,
        stePreSpe: false,
        soaDevis: false,
        soaPreSpe: false,
        centres: [],
    });
    const [refCtr, setRefCtr] = useState({
        ctrId: null,
        ctrComment: null,
    });
    const [validation, setValidation] = useState({
        isValidRequest: demandePassage.id !== 0 && demandePassage.id_status !== REQUEST_PASS_STATUS.NEW,
    });
    const [elemPatri, setElemPatri] = useState({
        isOpen: false,
        descr: {
            nomSection: null,
            axeSectionEnter: null,
            sensSectionEnter: null,
            departmentSectionEnter: null,
            citySectionEnter: null,
            descriptionSectionEnter: null,
            roadSectionEnter: null,
            axeSectionExit: null,
            sensSectionExit: null,
            departmentSectionExit: null,
            citySectionExit: null,
            descriptionSectionExit: null,
            roadSectionExit: null,
            elemPatri: [],
            expanded: true,
            prSectionEnter: null,
            prSectionExit: null,
            road: null,
            region: null,
            centre: null,
        },
    });
    const initialDescr = {
        numeroSection: 'A.1',
        nomSection: null,
        passType: null,
        charge: null,
        contresens: false,
        demontage: false,
        elemPatri: [],
        expanded: true,
        road: null,
        centre: null,
        centres: [],
        pointTypeEnter: null,
        pointCaracEnter: null,
        sensSectionEnter: null,
        citySectionEnter: null,
        prSectionEnter: null,
        pointTypeExit: null,
        pointCaracExit: null,
        sensSectionExit: null,
        citySectionExit: null,
        prSectionExit: null,
    };
    const initialDescrRetour = {
        numeroSection: null,
        nomSection: null,
        passType: null,
        contresens: false,
        charge: null,
        demontage: false,
        elemPatri: [],
        expanded: true,
        road: null,
        centre: null,
        centres: [],
        pointTypeEnter: null,
        pointCaracEnter: null,
        sensSectionEnter: null,
        citySectionEnter: null,
        prSectionEnter: null,
        pointTypeExit: null,
        pointCaracExit: null,
        sensSectionExit: null,
        citySectionExit: null,
        prSectionExit: null,
    };
    const [agGridOptions, setAgGridOptions] = useState({
        suppressCellSelection: true, suppressHorizontalScroll: false, animateRows: true,
    });
    const [validSteps, setValidSteps] = useState({
        step1: false,
        step2: false,
        step3: false,
        step4: false,
        step5: false,
        step6: false,
        step7: false,
        step8: false,
        step9: false,
    });
    const [clients, setClients] = useState([]);
    const [selectedTransporter, setSelectedTransporter] = useState('');
    const [selectedRepresentative, setSelectedRepresentative] = useState('');
    const [viewerIsOpen, setViewerIsOpen] = useState(false);
    const [viewerFile, setViewerFile] = useState(null);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const [openAlertModal, setOpenAlertModal] = useState(false);
    const [initialRequestPass, setInitialRequestPass] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [clientHasSap, setClientHasSap] = useState(false);
    const [entries, setEntries] = useState([]);
    const [natureChargeOptions, setNatureChargeOptions] = useState([]);
    // GATE-19 : verrou d'édition
    const [lockToken, setLockToken] = useState(null);
    const [lockConflictModal, setLockConflictModal] = useState(false);
    const lockTokenRef = useRef(null);
    const [openCancellationModal, setOpenCancellationModal] = useState(false);

    // Timer et setTimeOut pour la recherche de transporteur via TVA
    let timer;
    const waitTime = 2000;

    // region useEffect
    useEffect(() => {
        if (profil.profil === 6) {
            alert.error('Vous n\'êtes pas autorisé à accéder à la création d\'une demande de passage');
            navigate('/');
        } else {
            document.title = requestPassId === 0 ? 'TE - Création d\'un dossier' : 'TE - Edition d\'un dossier';
            setDemandePassage({ ...demandePassage, id: requestPassId });

            let visibleEntries = (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.INTERVENANT) ? adminEntries : clientEntries;

            // Si c'est une duplication, alors nous récupérons la demande à dupliquer, puis ajoutons les données nécessaires
            if (duplicateRequestPassId !== 0) {
                setOverlayLoading(true);
                getDuplicateRequestPass();
                getRequestPassDocuments();

                setEntries(visibleEntries);
            } else {
                // Chargement de la demande de passage
                if (requestPassId !== 0) {
                    setOverlayLoading(true);

                    setEntries([...visibleEntries, { name: 'tchat', description: 'Tchat' }]);

                    getRequestPass();
                    getRequestPassDocuments();
                } else {
                    let requestPassJSON = window.localStorage.getItem('requestPass');

                    setTimeout(() => {
                        if (requestPassJSON && requestPassJSON !== '') {
                            let requestPass = JSON.parse(requestPassJSON);
                            loadRequestPassIntoUI(requestPass);
                        } else {
                            let requestPass = buildRequestPass(false);
                            loadRequestPassIntoUI(requestPass);
                        }
                    }, 200);

                    setEntries(visibleEntries);
                }
            }

            apiListClientAccounts();
            apiListDepartments();
            getBlacklistedUsers();
            apiGetNatureChargeOptions();
        }
    }, []);
    useEffect(() => {
        if (isBuilding) return false;
        setThirdParty({
            transporteur: null,
            email: null,
            telephone1: null,
            telephone2: null,
            numSiren: null,
            numTva: null,
        });
    }, [complementIdentite.military]);
    useEffect(() => {
        if (isBuilding) return false;
        if (requestPassId === 0) {
            setComplementIdentite({
                value: complementIdentite.value,
                transporteur: null,
                adresse: null,
                complementAdresse: null,
                codePostal: null,
                commune: null,
                pays: null,
                email: null,
                telephone1: null,
                telephone2: null,
                fax: null,
                numSiren: null,
                numTva: null,
                military: 'false',
            });

            setRepresentative({
                transporteur: null,
                adresse: null,
                complementAdresse: null,
                codePostal: null,
                commune: null,
                pays: null,
                email: null,
                telephone1: null,
                telephone2: null,
                fax: null,
                numSiren: null,
                numTva: null,
            });

            if (complementIdentite.value === '0') {
                if (profil.profil !== PROFIL.ADMINISTRATEUR) {
                    setComplementIdentite({
                        ...complementIdentite,
                        transporteur: user.raison_sociale,
                        adresse: user.adresse,
                        complementAdresse: '',
                        codePostal: user.code_postal,
                        commune: user.commune,
                        pays: user.pays,
                        email: user.email,
                        telephone1: user.telephone_1,
                        telephone2: user.telephone_2,
                        fax: user.fax,
                        numSiren: user.num_siren,
                        numTva: user.num_tva,
                    });
                } else {
                    setComplementIdentite({
                        ...complementIdentite,
                        transporteur: null,
                        adresse: null,
                        complementAdresse: null,
                        codePostal: null,
                        commune: null,
                        pays: null,
                        email: null,
                        telephone1: null,
                        telephone2: null,
                        fax: null,
                        numSiren: null,
                        numTva: null,
                        military: 'false',
                    });
                }
            }

            if (complementIdentite.value === '1') {
                if (profil.profil !== PROFIL.ADMINISTRATEUR) {

                    setRepresentative({
                        ...representative,
                        transporteur: user.raison_sociale,
                        adresse: user.adresse,
                        complementAdresse: '',
                        codePostal: user.code_postal,
                        commune: user.commune,
                        pays: user.pays,
                        email: user.email,
                        telephone1: user.telephone1,
                        telephone2: user.telephone2,
                        fax: user.fax,
                        numSiren: user.num_siren,
                        numTva: user.num_tva,
                    });

                    setComplementIdentite({
                        ...complementIdentite,
                        transporteur: null,
                        adresse: null,
                        complementAdresse: null,
                        codePostal: null,
                        commune: null,
                        pays: null,
                        email: null,
                        telephone1: null,
                        telephone2: null,
                        fax: null,
                        numSiren: null,
                        numTva: null,
                        military: 'false',
                    });
                }
            }
        }

    }, [complementIdentite.value]);
    useEffect(() => {
        if (isBuilding) return false;
        let representativeData = selectedRepresentative?.data;
        if (representativeData) {
            setRepresentative({
                ...representative,
                transporteur: representativeData.raison_sociale,
                adresse: representativeData.adresse,
                complementAdresse: null,
                codePostal: representativeData.code_postal,
                commune: representativeData.commune,
                pays: representativeData.pays,
                email: representativeData.email,
                telephone1: representativeData.telephone1,
                telephone2: representativeData.telephone2,
                fax: representativeData.fax,
                numSiren: representativeData.num_siren,
                numTva: representativeData.num_tva,
                user_id: representativeData.user_id,
            });
        }
    }, [selectedRepresentative]);
    useEffect(() => {
        if (isBuilding) return false;
        let transporterData = selectedTransporter?.data;
        if (transporterData) {
            setComplementIdentite({
                ...complementIdentite,
                transporteur: transporterData.raison_sociale,
                adresse: transporterData.adresse,
                complementAdresse: null,
                codePostal: transporterData.code_postal,
                commune: transporterData.commune,
                pays: transporterData.pays,
                email: transporterData.email,
                telephone1: transporterData.telephone_1,
                telephone2: transporterData.telephone_2,
                fax: transporterData.fax,
                numSiren: transporterData.num_siren,
                numTva: transporterData.num_tva,
            });
        }
    }, [selectedTransporter]);
    useEffect(() => {
        validSteps.step1 && setNumberActiveStep(1);
        validSteps.step2 && setNumberActiveStep(2);
        validSteps.step3 && setNumberActiveStep(3);
        validSteps.step4 && setNumberActiveStep(4);
        validSteps.step5 && setNumberActiveStep(5);
        validSteps.step6 && setNumberActiveStep(6);
        validSteps.step7 && setNumberActiveStep(7);
        validSteps.step8 && setNumberActiveStep(8);
        validSteps.step9 && setNumberActiveStep(9);

        // GATE-19 : acquérir le verrou après le chargement du dossier
        if (!isBuilding && requestPassId !== 0 && duplicateRequestPassId === 0) {
            const canEdit = (
                profil.profil === PROFIL.ADMINISTRATEUR ||
                profil.profil === PROFIL.GESTIONNAIRE ||
                profil.profil === PROFIL.INTERVENANT ||
                (profil.profil === PROFIL.CLIENT && [
                    +REQUEST_PASS_STATUS.NEW,
                    +REQUEST_PASS_STATUS.WAITING_CLIENT,
                    +REQUEST_PASS_STATUS.WAITING_INTERN,
                    +REQUEST_PASS_STATUS.ON_GOING,
                ].includes(+demandePassage.id_status))
            );
            if (canEdit && lockTokenRef.current === null) {
                apiAcquireLock();
            }
        }

        if (requestPassId === 0) {
            // Sauvegarde dans le localStorage que lors de la création d'un dossier
            window.localStorage.setItem('requestPass', JSON.stringify(buildRequestPass(false)));
        }

    }, [reference, complementIdentite, caracConvoi, trajetDescr, datePassage, documents, validation, isBuilding]);
    useEffect(() => {
        let initialFiles = documents.initialFiles ? documents.initialFiles : [];

        if (demandePassage.id !== 0 && documents.initialFiles === null) {
            documents.files.forEach(function (fileData) {

                let file = dataUriToFile(fileData.data, fileData.fileName, fileData.mimeType);
                file.file = { name: fileData.fileName };
                initialFiles.push(file);

                // On ajoute la propriété id directement sur le fichier pour pouvoir l'identifier plus facilement
                Object.defineProperty(file, 'id', {
                    value: fileData.id, writable: true,
                });

                setDocuments({
                    ...documents,
                    initialFiles: initialFiles,
                });

            });
        } else {
            setDocuments({ ...documents, initialFiles: initialFiles });
        }
    }, [documents.files]);
    useEffect(() => {
        let initialFiles = adminDocuments.initialFiles ? adminDocuments.initialFiles : [];

        if (demandePassage.id !== 0 && adminDocuments.initialFiles === null) {
            adminDocuments.files.forEach(function (fileData) {

                let file = dataUriToFile(fileData.data, fileData.fileName, fileData.mimeType);
                initialFiles.push(file);

                // On ajoute la propriété id directement sur le fichier pour pouvoir l'identifier plus facilement
                Object.defineProperty(file, 'id', {
                    value: fileData.id, writable: true,
                });

                setAdminDocuments({ ...adminDocuments, initialFiles: initialFiles });
            });
        } else {
            setAdminDocuments({ ...adminDocuments, initialFiles: initialFiles });
        }
    }, [adminDocuments.files]);
    useEffect(() => {
        blacklistedUsersList.forEach((blacklisted_user) => {
            if (complementIdentite.value === IDENTITY_AGENT_TYPE.POUR_AUTRUI) {
                if (complementIdentite.transporteur === blacklisted_user) {
                    setBlacklisted(true);
                } else {
                    setBlacklisted(false);
                }
            } else {
                setBlacklisted(false);
            }
        });
    }, [complementIdentite.transporteur, complementIdentite.value, blacklistedUsersList]);
    useEffect(() => {
        if ((profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE)) {
            setNotAbleToChange(false);
        } else {
            switch (demandePassage.id_status) {
                case +REQUEST_PASS_STATUS.WAITING_CLIENT: {
                    if (profil.profil === PROFIL.CLIENT) {
                        setNotAbleToChange(false);
                    }
                    break;
                }
                case +REQUEST_PASS_STATUS.NEW: {
                    if (profil.profil === PROFIL.CLIENT) {
                        setNotAbleToChange(false);
                    }
                    break;
                }
                default: {
                    setNotAbleToChange((!(profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE)));
                }
            }
        }
    }, [demandePassage.id_status]);
    useEffect(() => {
        if (isBuilding) return false;
        switch (thirdParty.value) {
            case CLIENT_TYPE.MANDATAIRE:
                setThirdParty({
                    ...thirdParty,
                    transporteur: representative.transporteur,
                    email: representative.email,
                    telephone1: representative.telephone1,
                    telephone2: representative.telephone2,
                    numSiren: representative.numSiren,
                    numTva: representative.numTva,
                    numSap: representative.numSap,
                    numSapSubsidiary: representative.numSapSubsidiary,
                });
                break;
            case CLIENT_TYPE.TRANSPORTEUR:
                setThirdParty({
                    ...thirdParty,
                    transporteur: complementIdentite.transporteur,
                    email: complementIdentite.email,
                    telephone1: complementIdentite.telephone1,
                    telephone2: complementIdentite.telephone2,
                    numSiren: complementIdentite.numSiren,
                    numTva: complementIdentite.numTva,
                    numSap: complementIdentite.tiers ? complementIdentite.tiers.numSap : null,
                    numSapSubsidiary: complementIdentite.tiers ? complementIdentite.tiers.numSapSubsidiary : null,
                });
                break;
            case CLIENT_TYPE.TIER:
                setThirdParty({
                    ...thirdParty,
                    transporteur: null,
                    email: null,
                    telephone1: null,
                    telephone2: null,
                    numSiren: null,
                    numTva: null,
                    numSap: null,
                    numSapSubsidiary: null,
                });
                break;
        }
    }, [thirdParty.value]);

    useEffect(() => {
        if (!lockToken) return;
        const interval = setInterval(() => {
            axios({
                method: 'POST',
                url: `${URL_API}/demande-passage/${requestPassId}/lock/refresh`,
                params: { userAction: user.user_id, lockToken: lockToken },
            }).catch(() => { });
        }, 60000);
        return () => clearInterval(interval);
    }, [lockToken]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            const token = lockTokenRef.current;
            if (token && requestPassId !== 0) {
                navigator.sendBeacon(
                    `${URL_API}/demande-passage/${requestPassId}/lock/release?userAction=${user.user_id}&lockToken=${encodeURIComponent(token)}`
                );
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, []);

    // region gestion num TVA / SIREN
    useEffect(() => {
        const controller = new AbortController();
        const { signal } = controller;

        if (signal.aborted) {
            return;
        }

        if (!thirdParty.numTva || dataFetched) {
            return;
        }

        const fetchData = async () => {
            if (thirdParty.numTva && thirdParty.numSiren) {
                return;
            }

            if (thirdParty.value === CLIENT_TYPE.TIER) {
                await apiGetClientByTvaOrSiret(thirdParty.numTva, true, false, signal);
            } else {
                await apiGetSapNumber(thirdParty.numTva, signal);
            }
        };

        const timeoutId = setTimeout(() => {
            fetchData().then(() => setDataFetched(false));
        }, waitTime);

        return () => {
            clearTimeout(timeoutId);
            controller.abort();
        };
    }, [thirdParty.numTva, dataFetched]);

    useEffect(() => {
        if (!thirdParty.numSiren || !thirdParty.numTva || dataFetched) {
            return;
        }

        apiGetClientByTvaOrSiret(thirdParty.numSiren, true, true)
            .then(() => setDataFetched(false)); // Set dataFetched to true after fetching

    }, [thirdParty.numSiren, dataFetched]);

    useEffect(() => {
        if (!representative.numTva || thirdParty.numSiren) {
            return;
        }

        setDataFetched(true);

        setTimeout(() => {
            apiGetClientByTvaOrSiret(representative.numTva, false, false, true).then(r => setDataFetched(false));
        }, waitTime);
    }, [representative.numTva]);

    useEffect(() => {
        if (!representative.numSiren || thirdParty.numTva) {
            return;
        }

        setDataFetched(true);
        setTimeout(() => {
            apiGetClientByTvaOrSiret(representative.numSiren, false, true, true).then(r => setDataFetched(false));
        }, waitTime);
    }, [representative.numSiren]);
    // endregion

    useEffect(() => {
        let validationsCentres = [];

        complInfo.refCtr.map((refCtr) => {
            validationsCentres.push({
                id: refCtr.id,
                name: refCtr.name,
                devis: false,
                preSpe: false,
            });
        });

        setValidationSaisies({ ...validationSaisies, centres: validationsCentres });
    }, [complInfo.refCtr]);

    useEffect(() => {
        setClientHasSap(!!thirdParty.numSap);
    }, [thirdParty.numSap]);

    useEffect(() => {
        if (requestPassId !== 0) return;
        if (reference?.typeDemande === REQUEST_PASS_TYPE.SUPERIEUR) {
            let newDescr = trajetDescr.descr.map((section) => {
                return { ...section, passType: REQUEST_PASS_TYPE.SUPERIEUR };
            });
            let newDescrRetour = trajetDescr.descrRetour.map((section) => {
                return { ...section, passType: REQUEST_PASS_TYPE.SUPERIEUR };
            });

            dispatch(updateTrajetDescr('descr', newDescr));
            dispatch(updateTrajetDescr('descrRetour', newDescrRetour));
        } else {
            let newDescr = trajetDescr.descr.map((section) => {
                return { ...section, passType: null };
            });
            let newDescrRetour = trajetDescr.descrRetour.map((section) => {
                return { ...section, passType: null };
            });

            dispatch(updateTrajetDescr('descr', newDescr));
            dispatch(updateTrajetDescr('descrRetour', newDescrRetour));
        }
    }, [reference?.typeDemande]);
    // endregion

    // region functions
    const clearRequestPass = () => {
        dispatch(clearReference());
        dispatch(clearCaracConvoi());
        dispatch(clearInfosCompl());
        dispatch(clearTrajetDescr());
        setComplementIdentite({
            value: null,
            military: 'false',
            transporteur: null,
            adresse: null,
            complementAdresse: null,
            codePostal: null,
            commune: null,
            pays: null,
            email: null,
            telephone1: null,
            telephone2: null,
            fax: null,
            numSiren: null,
            numTva: null,
            mandataire: {
                transporteur: null,
                adresse: null,
                complementAdresse: null,
                codePostal: null,
                commune: null,
                pays: null,
                email: null,
                telephone1: null,
                telephone2: null,
                fax: null,
                numSiren: null,
                numTva: null,
            },
            tiers: {
                transporteur: null,
                email: null,
                telephone1: null,
                telephone2: null,
                fax: null,
                numSiren: null,
                numTva: null,
                numSap: null,
                numSapSubsidiary: null,
            },
        });
        setRepresentative({
            transporteur: null,
            adresse: null,
            complementAdresse: null,
            codePostal: null,
            commune: null,
            pays: null,
            email: null,
            telephone1: null,
            telephone2: null,
            fax: null,
            numSiren: null,
            numTva: null,
        });
        setThirdParty({
            value: CLIENT_TYPE.TIER,
            transporteur: null,
            email: null,
            telephone1: null,
            telephone2: null,
            numSiren: null,
            numTva: null,
            numSap: null,
            numSapSubsidiary: null,
        });
        setDatePassage({
            startDate: null, endDate: null,
            duration: null,
            nbPassageAller: null,
            nbVehiculeAller: null,
            nbPassageRetour: null,
            nbVehiculeRetour: null,
        });
        setTracingDossier({
            sendDate: null,
            returnDate: null,
            receptionDate: null,
            pickUpDate: null,
            transporterAnswerDate: null,
            billSendDate: null,
            billAmount: null,
            blackList: false,
            description: null,
            readAndSignedBy: null,
            alert: false,
        });
        setDocuments({
            files: [], initialFiles: null,
        });
        setAdminDocuments({
            files: [], initialFiles: null,
        });
        setValidationSaisies({
            steDevis: false,
            stePreSpe: false,
            soaDevis: false,
            soaPreSpe: false,
            centres: [],
        });
        setRefCtr({
            ctrId: null,
            ctrComment: null,
        });
        setValidation({
            isValidRequest: demandePassage.id !== 0 && demandePassage.id_status !== REQUEST_PASS_STATUS.NEW,
        });
        setElemPatri({
            isOpen: false,
            descr: {
                nomSection: null,
                axeSectionEnter: null,
                sensSectionEnter: null,
                departmentSectionEnter: null,
                citySectionEnter: null,
                descriptionSectionEnter: null,
                roadSectionEnter: null,
                axeSectionExit: null,
                sensSectionExit: null,
                departmentSectionExit: null,
                citySectionExit: null,
                descriptionSectionExit: null,
                roadSectionExit: null,
                elemPatri: [],
                expanded: true,
                prSectionEnter: null,
                prSectionExit: null,
                road: null,
                region: null,
                centre: null,
            },
        });
        setValidSteps({
            step1: false,
            step2: false,
            step3: false,
            step4: false,
            step5: false,
            step6: false,
            step7: false,
            step8: false,
            step9: false,
        });
        setClients([]);
        setSelectedTransporter('');
        setSelectedRepresentative('');
    };

    const handleClose = () => {
        // S'il y a une modification sur la demande de passage, on affichage la modale, dans le cas contraire on retourne directement sur la liste des demandes
        // Si la demande de passage est en cours de création
        if ((profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.CLIENT) &&
            detectChangeOnRequest({
                caracConvoi: caracConvoi,
                complInfo: complInfo,
                complementIdentite: complementIdentite,
                representative: representative,
                thirdParty: thirdParty,
                datePassage: datePassage,
                reference: reference,
                trajetDescr: trajetDescr,
                validSteps: validSteps,
                tracingDossier: tracingDossier,
            })) {
            // si on est en création, on sauvegarde le brouillon
            if (requestPassId === 0) {
                let requestPass = buildRequestPass(false);
                requestPass.hasChanged = true;
                window.localStorage.setItem('requestPass', JSON.stringify(requestPass));
            }
            setOpenConfirmationModal(true);
        } else {
            // si on est en création, on sauvegarde le brouillon
            if (requestPassId === 0) {
                let requestPass = buildRequestPass(false);
                requestPass.hasChanged = false;
                window.localStorage.setItem('requestPass', JSON.stringify(requestPass));
            }
            apiReleaseLock();
            clearRequestPass();
            navigate('/demande-passage');
        }
    };
    const onConfirmationModalClose = (value) => {
        if (value) {
            apiReleaseLock();
            clearRequestPass();
            navigate('/demande-passage');
        }
    };

    const onCancelModalClose = async () => {
        if (requestPassId) {
            await apiCancelRequest(requestPassId)
        }
        setOpenCancellationModal(false)
    };

    // Changement des valeurs du dossier
    const handleChange = (e, data, setData, pattern) => {
        if (e.target.value === '' || new RegExp(pattern).test(e.target.value)) {
            setData({ ...data, [e.target.name]: e.target.value });
        }
    };
    const handleChangeTextMask = (e, data, setData) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };
    const handleChangeDate = (data, setData, name, value) => {
        setData({ ...data, [name]: value });
    };
    const handleChangeCheckBox = (event, data, setData) => {
        setData({ ...data, [event.target.name]: event.target.checked });
    };
    const handleChangeSelectClient = (event, value, forTransporter = true) => {
        let selectedClient = null;

        if (value) {
            clients.map((c) => {
                if (c.key === value.key) {
                    selectedClient = c;
                }
            });

            if (selectedClient) {
                selectedClient.data.user_id = selectedClient.key;
                if (forTransporter) {
                    setSelectedTransporter(selectedClient);
                } else {
                    setSelectedRepresentative(selectedClient);
                }
            }
        }
    };
    const handleViewer = (file) => {
        if (file) {
            setViewerFile(file);
            setViewerIsOpen(true);
        }
    };
    const downloadFile = (file) => {
        // Remove the 'data:' prefix and split the base64 data from the MIME type
        let base64Data = file.data;
        if (file.data.includes('data:')) {
            base64Data = file.data.split(',')[1];
        }

        // Convert base64 to binary data
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Create a Blob object
        const blob = new Blob([byteArray], { type: file.mimeType });

        // Create a URL for the blob
        const url = URL.createObjectURL(blob);

        // Create a temporary anchor element and trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = file.fileName;
        document.body.appendChild(a);
        a.click();

        // Clean up by revoking the object URL
        window.URL.revokeObjectURL(url);
    };

    const handleChangeSearchClient = (event) => {
        let value = event.target.value;

        clearTimeout(timer);

        timer = setTimeout(() => {
            apiGetClientByTvaOrSiret(value);
        }, waitTime);
    };

    // Gestion des sections
    const createNewSection = (retour = false) => {
        let trajets = retour ? trajetDescr.descrRetour : trajetDescr.descr;

        trajets.push({
            numeroSection: null,
            nomSection: null,
            passType: reference?.typeDemande === REQUEST_PASS_TYPE.SUPERIEUR ? REQUEST_PASS_TYPE.SUPERIEUR : null,
            contresens: false,
            demontage: false,
            elemPatri: [],
            expanded: true,
            road: null,
            centre: null,
            charge: null,
            centres: [],

            pointTypeEnter: null,
            pointCaracEnter: null,
            sensSectionEnter: null,
            citySectionEnter: null,
            prSectionEnter: null,

            pointTypeExit: null,
            pointCaracExit: null,
            sensSectionExit: null,
            citySectionExit: null,
            prSectionExit: null,
        });

        dispatch(updateTrajetDescr(retour ? 'descrRetour' : 'descr', trajets));
    };
    const deleteSection = (event, indice, retour = false) => {
        event.stopPropagation();
        let trajets = retour ? trajetDescr.descrRetour : trajetDescr.descr;
        trajets.splice(indice, 1);
        trajets.forEach((trajet, index) => {
            trajet.numeroSection = retour ? `R.${index + 1}` : `A.${index + 1}`;
        });
        dispatch(updateTrajetDescr(retour ? 'descrRetour' : 'descr', trajets));
    };

    // Préparation de l'objet datas
    const getDemandePassageDatas = () => {
        return {
            reference: reference, complementIdentite: complementIdentite, caracConvoi: caracConvoi,
        };
    };

    const onNextStep = (setter, variable, step) => {
        if (!validSteps['step' + step]) {
            if (checkRequestValues(step)) {
                setValidSteps({ ...validSteps, ['step' + step]: !validSteps['step' + step] });
                setNumberActiveStep(step);
            }
        } else {
            setValidSteps({ ...validSteps, ['step' + step]: !validSteps['step' + step] });
        }
    };
    const onOpenElemPatri = (elem = null) => {
        setElemPatri({ ...elemPatri, isOpen: true, descr: elem });
    };
    const fileToDataUri = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            resolve(event.target.result);
        };
        reader.readAsDataURL(file);
    });

    // Pour charger les fichiers dans la dropbox
    const dataUriToFile = (dataUri, filename, mimeType) => {
        let arr = dataUri.split(',');

        let mime = mimeType ? mimeType : arr[0].match(/:(.*?);/)[1];

        let bstr = Buffer.from(arr[1] ?? dataUri, 'base64');

        return new File([bstr], filename, { type: mime });
    };

    const onDropZoneAreaChange = async (files, documentType) => {
        let dropZoneDocuments = [];

        if (files.length > 0) {
            const promises = files.map(fileObject => {
                let file = fileObject.file;
                let fileExist = false;

                if (documentType === DOCUMENT_TYPE.DOCUMENT) {
                    fileExist = documents.files.find((doc) => doc.fileName === file.name);
                } else {
                    fileExist = adminDocuments.files.find((doc) => doc.fileName === file.name);
                }

                if (fileExist) {
                    alert.error('Un fichier avec le même nom existe déjà');
                    return;
                }

                return fileToDataUri(file).then((base64) => {
                    let data = base64.split(',')[1];

                    dropZoneDocuments.push({
                        id: file.id | 0,
                        data: data,
                        name: file.name,
                        mimeType: file.type,
                        documentType: documentType,
                        fileName: file.name,
                        file: {
                            name: file.name,
                        },
                    });
                });
            });

            await Promise.all(promises);
        } else {
            if (documentType === DOCUMENT_TYPE.DOCUMENT) {
                let filteredDocuments = documents.files.filter((doc) => doc.fileName !== files.fileName);
                setDocuments({ ...documents, files: filteredDocuments });
            } else {
                let filteredDocuments = adminDocuments.files.filter((doc) => doc.fileName !== files.fileName);
                setAdminDocuments({ ...adminDocuments, files: filteredDocuments });
            }

            return;
        }

        if (documentType === DOCUMENT_TYPE.DOCUMENT) {
            let mergedDocuments = [...documents.files, ...dropZoneDocuments];
            setDocuments({ ...documents, files: mergedDocuments });
        } else {
            let mergedDocuments = [...adminDocuments.files, ...dropZoneDocuments];
            setAdminDocuments({ ...adminDocuments, files: mergedDocuments });
        }
    };

    const loadRequestPassIntoUI = (requestPassData) => {
        if (requestPassData.planifications && requestPassData.planifications.length > 0)
            requestPassData.planifications = requestPassData.planifications.filter(p => !p.deleted);

        setDossier(requestPassData);
        let caracConvoiData = requestPassData.metadata.caracConvoi;
        let complementIdentiteData = requestPassData.metadata.complementIdentite;
        let datePassageData = requestPassData.metadata.datePassage;
        let referenceData = requestPassData.metadata.reference;
        let trajetDescrData = requestPassData.metadata.trajetDescr;
        let valSteps = requestPassData.metadata.validSteps;
        let tracingDossier = requestPassData.metadata.tracingDossier;
        let complInfo = requestPassData.metadata.complInfo;
        let validationSaisies = requestPassData.metadata.validationSaisies;

        if (initialRequestPass === null) {
            setInitialRequestPass({
                caracConvoi: requestPassData.metadata.caracConvoi,
                complementIdentite: requestPassData.metadata.complementIdentite,
                datePassage: requestPassData.metadata.datePassage,
                reference: requestPassData.metadata.reference,
                trajetDescription: requestPassData.metadata.trajetDescr,
                validSteps: requestPassData.metadata.validSteps,
                tracingDossier: requestPassData.metadata.tracingDossier,
                complInfo: requestPassData.metadata.complInfo,
            });
        }

        setValidSteps({
            ...validSteps,
            step1: valSteps.step1,
            step2: valSteps.step2,
            step3: valSteps.step3,
            step4: valSteps.step4,
            step5: valSteps.step5,
            step6: valSteps.step6,
            step7: valSteps.step7,
            step8: valSteps.step8,
            step9: valSteps.step9,
        });
        setDemandePassage({
            ...demandePassage,
            id_status: requestPassData.id_status,
            planifications: requestPassData.planifications
        });
        let caracConvoiDispatch = {
            ...caracConvoi,
            accompagnement: caracConvoiData.accompagnement,
            masseTotaleVide: caracConvoiData.masseTotaleVide,
            longueurVide: caracConvoiData.longueurVide,
            largeurVide: caracConvoiData.largeurVide,
            hauteurVide: caracConvoiData.hauteurVide,
            masseTotaleCharge: caracConvoiData.masseTotaleCharge,
            longueurCharge: caracConvoiData.longueurCharge,
            largeurCharge: caracConvoiData.largeurCharge,
            hauteurCharge: caracConvoiData.hauteurCharge,
            natureCharge: caracConvoiData.natureCharge,
            vitesseCircuCharge: caracConvoiData.vitesseCircuCharge,
            nbVehicule: caracConvoiData.nbVehicule,
            nbTransExcept: caracConvoiData.nbTransExcept,
            nbRames: caracConvoiData.nbRames,
            configurations: caracConvoiData.configurations ?? [],
            category: caracConvoiData.category,
        };

        dispatch(loadCaracConvoi(caracConvoiDispatch));

        // WORKAROUND le premier setComplementIdentite ne fonctionne pas ?
        setComplementIdentite({
            ...complementIdentite,
            value: complementIdentiteData.value,
            transporteur: complementIdentiteData.transporteur,
            adresse: complementIdentiteData.adresse,
            complementAdresse: complementIdentiteData.complementAdresse,
            codePostal: complementIdentiteData.codePostal,
            commune: complementIdentiteData.commune,
            pays: complementIdentiteData.pays,
            email: complementIdentiteData.email,
            telephone1: complementIdentiteData.telephone1,
            telephone2: complementIdentiteData.telephone2,
            fax: complementIdentiteData.fax,
            numSiren: complementIdentiteData.numSiren,
            numTva: complementIdentiteData.numTva,
            mandataire: complementIdentiteData.mandataire,
            tiers: complementIdentiteData.tiers,
            military: complementIdentiteData.military,
        });

        if (complementIdentiteData.mandataire) {
            setRepresentative({
                ...complementIdentiteData.mandataire,
                numTva: complementIdentiteData.mandataire.numTva,
                numSiren: complementIdentiteData.mandataire.numSiren,
            });
        }

        if (complementIdentiteData.tiers) {
            setThirdParty(complementIdentiteData.tiers);
        }

        setDatePassage({
            ...datePassage,
            startDate: datePassageData.startDate,
            endDate: datePassageData.endDate,
            duration: Number(datePassageData.duration),
            nbPassageAller: Number(datePassageData.nbPassageAller),
            nbVehiculeAller: Number(datePassageData.nbVehiculeAller),
            nbPassageRetour: Number(datePassageData.nbPassageRetour),
            nbVehiculeRetour: Number(datePassageData.nbVehiculeRetour),
        });

        let referenceDataDispatch = {
            ...reference,
            numDossier: referenceData.numDossier,
            numSiren: referenceData.numSiren,
            typeDemande: requestPassData.type_request,
            departments: referenceData.departments ?? [],
        };

        dispatch(loadReference(referenceDataDispatch));

        let newDescr = trajetDescrData.descr.map((trajet) => {
            return { ...trajet, centres: trajet.centres ?? [], elemPatri: trajet.elemPatri ?? [] };
        });

        let newDescRetour = trajetDescrData.descrRetour.map((trajet) => {
            return { ...trajet, centres: trajet.centres ?? [], elemPatri: trajet.elemPatri ?? [] };
        });

        let dispatchTrajetDescr = {
            ...trajetDescr,
            descr: newDescr,
            descrRetour: newDescRetour,
            type: trajetDescrData.type,
            depart: trajetDescrData.depart,
            arrivee: trajetDescrData.arrivee,
        };

        dispatch(loadTrajetDescr(dispatchTrajetDescr));

        let readAndSignedBy = '';

        if (!tracingDossier.readAndSignedBy) {
            if (requestPassData.user) {
                if (requestPassData.user.raison_sociale) {
                    readAndSignedBy = requestPassData.user.raison_sociale;
                } else if (requestPassData.user.prenom || requestPassData.user.nom) {
                    readAndSignedBy = requestPassData.user.prenom + ' ' + requestPassData.user.nom.toUpperCase();
                } else {
                    readAndSignedBy = requestPassData.user.login;
                }
            }
        } else {
            readAndSignedBy = tracingDossier.readAndSignedBy;
        }

        setTracingDossier({
            ...tracingDossier,
            sendDate: tracingDossier.sendDate,
            returnDate: tracingDossier.returnDate,
            receptionDate: tracingDossier.receptionDate ?? moment(),
            pickUpDate: tracingDossier.pickUpDate,
            transporterAnswerDate: tracingDossier.transporterAnswerDate,
            billSendDate: tracingDossier.billSendDate,
            billAmount: tracingDossier.billAmount,
            blackList: tracingDossier.blackList,
            description: tracingDossier.description,
            readAndSignedBy: readAndSignedBy,
            alert: tracingDossier.alert,
        });

        // WORKAROUND: pour les anciens dossiers le chargement peut rester bloquer par-delà ce point
        setOverlayLoading(false);

        let dispatchComplInfo = {
            ...complInfo,
            dateArrete: complInfo.dateArrete,
            desc1Number: complInfo.desc1Number,
            desc1Date: complInfo.desc1Date,
            desc1Label: complInfo.desc1Label,
            desc2Number: complInfo.desc2Number,
            desc2Date: complInfo.desc2Date,
            desc2Label: complInfo.desc2Label,
            horPassDebut: complInfo.horPassDebut,
            horPassFin: complInfo.horPassFin,
            servTeInfo: complInfo.servTeInfo,
            servOaInfo: complInfo.servOaInfo,
            refCtr: complInfo.refCtr,
        };

        dispatch(loadInfosCompl(dispatchComplInfo));

        setValidationSaisies({
            ...validationSaisies,
            steDevis: validationSaisies.steDevis,
            stePreSpe: validationSaisies.stePreSpe,
            soaDevis: validationSaisies.soaDevis,
            soaPreSpe: validationSaisies.soaPreSpe,
            centres: validationSaisies.centres,
        });

        setBuilding(false);
    };

    const renderDropZonePreview = (file) => {
        if (file.mimeType.split('/')[0] === 'image') {
            let srcData = file.data.includes('data:image') ? file.data : 'data:image/jpeg;base64,' + file.data;

            return (<>
                <div className={notAbleToChange ? 'drop-preview' : ''} onClick={() => {
                    handleViewer(file);
                }}>
                    <img className='dropzone-preview-image' role='presentation' src={srcData} />
                </div>
                <label style={{ fontWeight: 'bold' }}>{file.fileName}</label></>);
        }
        if (file.mimeType.split('/')[1] === 'pdf') {
            return (<>
                <div onClick={() => {
                    downloadFile(file);
                }}>
                    <FontAwesomeIcon icon={faFilePdf}
                        className='dropzone-preview-image'
                        style={{
                            fontSize: '150px',
                        }} />
                </div>
                <label style={{ fontWeight: 'bold' }}>{file.fileName}</label>
            </>);
        }
        if (file.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            return (<>
                <div onClick={() => {
                    downloadFile(file);
                }}>
                    <FontAwesomeIcon icon={faFileExcel}
                        className='dropzone-preview-image'
                        style={{
                            fontSize: '150px',
                        }} />
                </div>
                <label style={{ fontWeight: 'bold' }}>{file.fileName}</label>
            </>);
        }
        return (<>
            <div onClick={() => {
                downloadFile(file);
            }}>
                <FontAwesomeIcon icon={faFile}
                    className='dropzone-preview-image'
                    style={{
                        fontSize: '150px',
                    }} />
            </div>
            <label style={{ fontWeight: 'bold' }}>{file.fileName}</label>
        </>);
    };
    const checkRequestValues = (step) => {
        if (!notAbleToChange) {
            switch (step) {
                case 1:
                    if (!reference?.typeDemande) {
                        alert.error('Un type de demande est requis');
                        return false;
                    }

                    if (!reference?.numDossier || reference?.numDossier === '') {
                        alert.error('Référence DDT non renseignée');
                        return false;
                    }

                    if (reference?.departments.length === 0) {
                        alert.error('Un département est requis');
                        return false;
                    }

                    if (reference?.typeDemande === REQUEST_PASS_TYPE.SUPERIEUR && reference?.departments.length > 1) {
                        alert.error('Un seul département est requis pour une demande de passage supérieur');
                        return false;
                    }
                    break;
                case 2:
                    if (!complementIdentite.transporteur || complementIdentite.transporteur === '') {
                        alert.error('Le nom du transporteur est requis');
                        return false;
                    }

                    if (!complementIdentite.numTva) {
                        alert.error('Le N° TVA du transporteur est requis pour la complétion du dossier');
                        return false;
                    }

                    if (complementIdentite.military === 'false' && (!thirdParty.numTva)) {
                        alert.error('Le N° TVA du tiers facturé est requis pour la complétion du dossier');
                        return false;
                    }

                    if (!complementIdentite.adresse || complementIdentite.adresse === '') {
                        alert.error('L\'adresse du transporteur est requise');
                        return false;
                    }
                    if (!complementIdentite.codePostal || complementIdentite.codePostal === '') {
                        alert.error('Le code postal du transporteur est requis');
                        return false;
                    }
                    if (!complementIdentite.commune || complementIdentite.commune === '') {
                        alert.error('La commune du transporteur est requise');
                        return false;
                    }
                    if (!complementIdentite.pays || complementIdentite.pays === '') {
                        alert.error('Le pays du transporteur est requis');
                        return false;
                    }
                    if (!complementIdentite.email || complementIdentite.email === '') {
                        alert.error('L\'adresse mail du transporteur est requise');
                        return false;
                    }
                    break;
                case 3:
                    if ((REQUEST_PASS_STATUS.WAITING_INTERN === demandePassage.id_status || REQUEST_PASS_STATUS.WAITING_CLIENT === demandePassage.id_status) || REQUEST_PASS_STATUS.BLOCKED === demandePassage.id_status || REQUEST_PASS_STATUS.ON_GOING === demandePassage.id_status) {
                        return true;
                    }
                    let needConf = false;
                    let configurations = caracConvoi.configurations;
                    let displayMilitary = reference?.typeDemande === REQUEST_PASS_TYPE.SUPERIEUR ? 'true' : (trajetDescr.descr.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.SUPERIEUR || trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && trajetDescr.descrRetour.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.SUPERIEUR)));
                    if (trajetDescr.descr.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.SUPERIEUR)) {
                        needConf = true;
                    }

                    if (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && trajetDescr.descrRetour.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.SUPERIEUR)) {
                        needConf = true;
                    }

                    if (needConf && configurations.length === 0) {
                        alert.error('La configuration du convoi est requise');
                        return false;
                    }

                    if (complementIdentite.military === 'true' && (!caracConvoi.nbVehicule || caracConvoi.nbVehicule === '')) {
                        alert.error('Le nombre de véhicules est requis');
                        return false;
                    }

                    if (complementIdentite.military === 'true' && (!caracConvoi.nbTransExcept || caracConvoi.nbTransExcept === '')) {
                        alert.error('Le nombre de transport exceptionnel est requis');
                        return false;
                    }

                    if (complementIdentite.military === 'true' && (!caracConvoi.nbRames || caracConvoi.nbRames === '')) {
                        alert.error('Le nombre de rames est requis');
                        return false;
                    }

                    if (((complementIdentite.military === null || complementIdentite.military === 'false') || (displayMilitary && complementIdentite.military === 'true')) && configurations.some((conf) => !conf.chargeMaxiEssieu || conf.chargeMaxiEssieu === '' || conf.chargeMaxiEssieu === null)) {
                        alert.error('Les masses maxi en charge réelle sont requises');
                        return false;
                    }

                    if (((complementIdentite.military === null || complementIdentite.military === 'false') || (displayMilitary && complementIdentite.military === 'true')) && configurations.some((conf) => !conf.distanceMiniInterEssieu || conf.distanceMiniInterEssieu === '' || conf.distanceMiniInterEssieu === null)) {
                        alert.error('Les distances mini inter-essieux sont requises');
                        return false;
                    }

                    if (demandePassage.id_status !== REQUEST_PASS_STATUS.NEW && needConf && configurations.some((conf) => String(conf.validation) !== '0')) {
                        alert.error('Les configurations du convoi doivent être validées');
                        return false;
                    }

                    if (complementIdentite.military === 'false' && (!caracConvoi.natureCharge || caracConvoi.natureCharge === '')) {
                        alert.error('La nature du convoi /chargement est requise');
                        return false;
                    }
                    if (!caracConvoi.masseTotaleVide || caracConvoi.masseTotaleVide === '') {
                        alert.error('La masse totale roulante à vide est requise');
                        return false;
                    }
                    if (!caracConvoi.longueurVide || caracConvoi.longueurVide === '') {
                        alert.error('La longueur totale à vide est requise');
                        return false;
                    }
                    if (!caracConvoi.largeurVide || caracConvoi.largeurVide === '') {
                        alert.error('La largeur totale à vide est requise');
                        return false;
                    }
                    if (!caracConvoi.hauteurVide || caracConvoi.hauteurVide === '') {
                        alert.error('La hauteur totale à vide est requise');
                        return false;
                    }
                    if (!caracConvoi.masseTotaleCharge || caracConvoi.masseTotaleCharge === '') {
                        alert.error('La masse totale roulante en charge est requise');
                        return false;
                    }
                    if (!caracConvoi.longueurCharge || caracConvoi.longueurCharge === '') {
                        alert.error('La longueur totale en charge est requise');
                        return false;
                    }
                    if (!caracConvoi.largeurCharge || caracConvoi.largeurCharge === '') {
                        alert.error('La largeur totale en charge est requise');
                        return false;
                    }
                    if (!caracConvoi.hauteurCharge || caracConvoi.hauteurCharge === '') {
                        alert.error('La hauteur totale en charge est requise');
                        return false;
                    }
                    if (!caracConvoi.natureCharge || caracConvoi.natureCharge === '') {
                        alert.error('La nature du chargement est requise');
                        return false;
                    }
                    break;
                case 4:
                    if (trajetDescr.descr.length === 0 || (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && trajetDescr.descrRetour.length === 0)) {
                        alert.error('Au moins un tronçons est requis');
                        return false;
                    }
                    if (!trajetDescr.depart || !trajetDescr.arrivee || trajetDescr.depart === '' || trajetDescr.arrivee === '') {
                        alert.error('Les points de départ et d\'arrivée sont requis');
                        return false;
                    }
                    if (trajetDescr.descr.some((trajet) => (!trajet.nomSection || trajet.nomSection === '')) || (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && trajetDescr.descrRetour.some((trajet) => (!trajet.nomSection || trajet.nomSection === '')))) {
                        alert.error('Les noms des tronçons sont requis');
                        return false;
                    }
                    if (trajetDescr.descr.some((trajet) => (!trajet.road || trajet.road === '')) || (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && trajetDescr.descrRetour.some((trajet) => (!trajet.road || trajet.road === '')))) {
                        alert.error('Les axes sont requis');
                        return false;
                    }

                    if (trajetDescr.descr.some((trajet) => !trajet.passType || (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && trajetDescr.descrRetour.some((trajet) => !trajet.passType)))) {
                        alert.error('Les types de passage sont requis');
                        return false;
                    }

                    if (trajetDescr.descr.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.SUPERIEUR && (!trajet.citySectionEnter || trajet.citySectionEnter === '') && (!trajet.roadSectionEnter || trajet.roadSectionEnter === '') && (!trajet.descriptionSectionEnter || trajet.descriptionSectionEnter === '')) || (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && trajetDescr.descrRetour.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.SUPERIEUR && (!trajet.citySectionEnter || trajet.citySectionEnter === '') && (!trajet.roadSectionEnter || trajet.roadSectionEnter === '') && (!trajet.descriptionSectionEnter || trajet.descriptionSectionEnter === '')))) {
                        alert.error('La commune, la route ou la description sont requis');
                        return false;
                    }

                    if (trajetDescr.descr.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE && (!trajet.pointTypeEnter || trajet.pointTypeEnter === '') || (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && trajetDescr.descrRetour.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE && (!trajet.pointTypeEnter || trajet.pointTypeEnter === ''))))) {
                        alert.error('Les types de points sont requis');
                        return false;
                    }
                    if (trajetDescr.descr.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE && (!trajet.pointTypeExit || trajet.pointTypeExit === '') || (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && trajetDescr.descrRetour.some((trajet) => trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE && (!trajet.pointTypeExit || trajet.pointTypeExit === ''))))) {
                        alert.error('Les types de points sont requis');
                        return false;
                    }

                    if (trajetDescr.descr.some((trajet) => trajet.charge === null || (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && trajetDescr.descrRetour.some((trajet) => trajet.charge === null)))) {
                        alert.error('Les informations de charge sont requises');
                        return false;
                    }

                    if (trajetDescr.descr.some((trajet) =>
                        trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE &&
                        trajet.pointTypeEnter !== 'Limite de concession' &&
                        (!trajet.pointCaracEnter && !trajet.citySectionEnter) ||
                        (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR &&
                            trajetDescr.descrRetour.some((trajet) =>
                                trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE &&
                                trajet.pointTypeEnter !== 'Limite de concession' &&
                                (!trajet.pointCaracEnter && !trajet.citySectionEnter),
                            )
                        ),
                    )) {
                        alert.error('Les points caractéristiques ou la commune sont requis');
                        return false;
                    }
                    if (trajetDescr.descr.some((trajet) =>
                        trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE &&
                        trajet.pointTypeExit !== 'Limite de concession' &&
                        (!trajet.pointCaracExit && !trajet.citySectionExit) ||
                        (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR &&
                            trajetDescr.descrRetour.some((trajet) =>
                                trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE &&
                                trajet.pointTypeExit !== 'Limite de concession' &&
                                (!trajet.pointCaracExit && !trajet.citySectionExit),
                            )
                        ),
                    )) {
                        alert.error('Les points caractéristiques ou la commune sont requis');
                        return false;
                    }
                    if (trajetDescr.descr.some((trajet) =>
                        trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE &&
                        trajet.pointTypeEnter === 'Limite de concession' &&
                        (!trajet.prSectionEnter && !trajet.citySectionEnter) ||
                        (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR &&
                            trajetDescr.descrRetour.some((trajet) =>
                                trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE &&
                                trajet.pointTypeEnter === 'Limite de concession' &&
                                (!trajet.prSectionEnter && !trajet.citySectionEnter),
                            )
                        ),
                    )) {
                        alert.error('Le PR ou la commune sont requis');
                        return false;
                    }
                    if (trajetDescr.descr.some((trajet) =>
                        trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE &&
                        trajet.pointTypeExit === 'Limite de concession' &&
                        !trajet.prSectionExit && !trajet.citySectionExit ||
                        (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR &&
                            trajetDescr.descrRetour.some((trajet) =>
                                trajet.passType === REQUEST_PASS_TYPE.AUTOROUTE &&
                                trajet.pointTypeExit === 'Limite de concession' &&
                                !trajet.prSectionExit && !trajet.citySectionExit,
                            )
                        ),
                    )) {
                        alert.error('Le PR ou la commune sont requis');
                        return false;
                    }
                    break;
                case 5:
                    if (reference?.typeDemande !== REQUEST_PASS_TYPE.SUPERIEUR && (!datePassage.startDate || datePassage.startDate === '' || datePassage.startDate === 'Invalid date')) {
                        alert.error('La date de début souhaitée est requise');
                        return false;
                    }
                    if (!datePassage.duration || datePassage.duration === '' || datePassage.duration === 'Invalid date') {
                        alert.error('La durée de passage souhaitée est requise');
                        return false;
                    }
                    if (datePassage.nbPassageAller === 0 || (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && datePassage.nbPassageRetour === 0)) {
                        alert.error('Le nombre de passage est requis');
                        return false;
                    }

                    if (reference?.typeDemande === REQUEST_PASS_TYPE.AUTOROUTE && datePassage.nbVehiculeAller === 0 || (trajetDescr.type === TRJT_TYPE.ALLER_RETOUR && datePassage.nbVehiculeRetour === 0)) {
                        alert.error('Le nombre de véhicules est requis');
                        return false;
                    }
                    break;
                case 6:
                    if (reference?.typeDemande === REQUEST_PASS_TYPE.AUTOROUTE) {
                        if (documents.files.length < 2) {
                            alert.error('Le document CERFA et le document de reconnaissance du trajet sont requis');
                            return false;
                        }
                    } else {
                        if (documents.files.length < 1) {
                            alert.error('Le document CERFA est requis');
                            return false;
                        }
                    }
                    break;
            }
        }

        return true;
    };
    const buildRequestPass = (withDocuments = true) => {
        let metadata = {
            reference: {
                numDossier: reference?.numDossier,
                numSiren: reference?.numSiren,
                departments: reference?.departments,
                typeDemande: reference?.typeDemande,
            },
            complementIdentite: {
                value: complementIdentite.value,
                military: complementIdentite.military,
                transporteur: complementIdentite.transporteur,
                adresse: complementIdentite.adresse,
                complementAdresse: complementIdentite.complementAdresse,
                codePostal: complementIdentite.codePostal,
                commune: complementIdentite.commune,
                pays: complementIdentite.pays,
                email: complementIdentite.email,
                telephone1: complementIdentite.telephone1,
                telephone2: complementIdentite.telephone2,
                fax: complementIdentite.fax,
                numSiren: complementIdentite.numSiren,
                numTva: complementIdentite.numTva,
                mandataire: representative,
                tiers: thirdParty,
            },
            caracConvoi: {
                masseTotaleVide: caracConvoi.masseTotaleVide,
                longueurVide: caracConvoi.longueurVide,
                largeurVide: caracConvoi.largeurVide,
                hauteurVide: caracConvoi.hauteurVide,
                masseTotaleCharge: caracConvoi.masseTotaleCharge,
                longueurCharge: caracConvoi.longueurCharge,
                largeurCharge: caracConvoi.largeurCharge,
                hauteurCharge: caracConvoi.hauteurCharge,
                natureCharge: caracConvoi.natureCharge,
                vitesseCircuCharge: caracConvoi.vitesseCircuCharge,
                accompagnement: caracConvoi.accompagnement,
                nbVehicule: caracConvoi.nbVehicule,
                nbTransExcept: caracConvoi.nbTransExcept,
                nbRames: caracConvoi.nbRames,
                configurations: caracConvoi.configurations,
                category: caracConvoi.category,
            },
            trajetDescr: {
                depart: trajetDescr.depart,
                arrivee: trajetDescr.arrivee,
                type: trajetDescr.type,
                descr: trajetDescr.descr,
                descrRetour: trajetDescr.descrRetour ?? [],
            },
            datePassage: {
                startDate: datePassage.startDate !== 'Invalid date' ? moment(datePassage.startDate).startOf('day').format() : '',
                endDate: datePassage.endDate !== 'Invalid date' ? moment(datePassage.endDate).endOf('day').format() : '',
                duration: Number(datePassage.duration),
                nbPassageAller: Number(datePassage.nbPassageAller),
                nbVehiculeAller: Number(datePassage.nbVehiculeAller),
                nbPassageRetour: Number(datePassage.nbPassageRetour),
                nbVehiculeRetour: Number(datePassage.nbVehiculeRetour),
            },
            validSteps: {
                step1: validSteps.step1,
                step2: validSteps.step2,
                step3: validSteps.step3,
                step4: validSteps.step4,
                step5: validSteps.step5,
                step6: validSteps.step6,
                step7: validSteps.step7,
                step8: validSteps.step8,
                step9: validSteps.step9,
            },
            tracingDossier: {
                sendDate: tracingDossier.sendDate,
                returnDate: tracingDossier.returnDate,
                receptionDate: tracingDossier.receptionDate,
                pickUpDate: tracingDossier.pickUpDate,
                transporterAnswerDate: tracingDossier.transporterAnswerDate,
                readAndSignedBy: tracingDossier.readAndSignedBy ?? '',
                billSendDate: tracingDossier.billSendDate,
                billAmount: tracingDossier.billAmount,
                blackList: tracingDossier.blackList,
                description: tracingDossier.description,
                alert: tracingDossier.alert,
            },
            complInfo: {
                dateArrete: complInfo.dateArrete,
                desc1Number: complInfo.desc1Number,
                desc1Date: complInfo.desc1Date,
                desc1Label: complInfo.desc1Label,
                desc2Number: complInfo.desc2Number,
                desc2Date: complInfo.desc2Date,
                desc2Label: complInfo.desc2Label,
                horPassDebut: complInfo.horPassDebut,
                horPassFin: complInfo.horPassFin,
                servTeInfo: complInfo.servTeInfo,
                servOaInfo: complInfo.servOaInfo,
                refCtr: complInfo.refCtr,
            },
            validationSaisies: {
                steDevis: validationSaisies.steDevis,
                stePreSpe: validationSaisies.stePreSpe,
                soaDevis: validationSaisies.soaDevis,
                soaPreSpe: validationSaisies.soaPreSpe,
                centres: validationSaisies.centres,
            },
        };

        return {
            id: requestPassId,
            id_status: demandePassage.id_status,
            metadata: metadata,
            type_request: reference?.typeDemande,
            documents: withDocuments ? [...documents.files, ...adminDocuments.files] : [],
            facturations: dossier.facturations,
        };
    };

    // Génération du contenu de la modale
    const getContent = () => {
        return <>
            {entries.some((entry) => entry.name === 'infos_gen') &&
                <StepControleRef
                    refs={refs}
                    profil={profil}
                    handleChange={handleChange}
                    reference={reference}
                    demandePassageStyle={demandePassageStyle}
                    notAbleToChange={profil.profil === PROFIL.INTERVENANT ? true : notAbleToChange}
                    demandePassage={demandePassage}
                    departments={departments}
                    validSteps={validSteps}
                    onNextStep={onNextStep}
                />
            }
            {entries.some((entry) => entry.name === 'identite_mandataire') &&
                <StepIdentiteMandataireEtTransporteur
                    refs={refs}
                    profil={profil}
                    complementIdentite={complementIdentite}
                    setComplementIdentite={setComplementIdentite}
                    handleChange={handleChange}
                    notAbleToChange={profil.profil === PROFIL.INTERVENANT ? true : notAbleToChange}
                    blacklisted={blacklisted}
                    clients={clients}
                    clientHasSap={clientHasSap}
                    demandePassageStyle={demandePassageStyle}
                    representative={representative}
                    setRepresentative={setRepresentative}
                    selectedRepresentative={selectedRepresentative}
                    handleChangeSelectClient={handleChangeSelectClient}
                    handleChangeSearchClient={handleChangeSearchClient}
                    handleChangeTextMask={handleChangeTextMask}
                    PhoneMask={PhoneMask}
                    thirdParty={thirdParty}
                    setThirdParty={setThirdParty}
                    selectedTransporter={selectedTransporter}
                    demandePassage={demandePassage}
                    validSteps={validSteps}
                    onNextStep={onNextStep}
                    reference={reference}
                    dataFetched={dataFetched}
                />
            }
            {entries.some((entry) => entry.name === 'caract_convoi') &&
                <StepCaractConvoi
                    refs={refs}
                    profil={profil}
                    demandePassageStyle={demandePassageStyle}
                    handleChange={handleChange}
                    demandePassage={demandePassage}
                    reference={reference}
                    complementIdentite={complementIdentite}
                    caracConvoi={caracConvoi}
                    notAbleToChange={profil.profil === PROFIL.INTERVENANT ? true : notAbleToChange}
                    handleChangeCheckBox={handleChangeCheckBox}
                    validSteps={validSteps}
                    onNextStep={onNextStep}
                    setOpenAlertModal={setOpenAlertModal}
                    trajetDescr={trajetDescr}
                    natureChargeOptions={natureChargeOptions}
                />
            }
            {entries.some((entry) => entry.name === 'trajet_descr') &&
                <StepTrajetDescr
                    refs={refs}
                    profil={profil}
                    elemPatri={elemPatri}
                    setElemPatri={setElemPatri}
                    demandePassageStyle={demandePassageStyle}
                    caracConvoi={caracConvoi}
                    trajetDescr={trajetDescr}
                    complInfo={complInfo}
                    notAbleToChange={profil.profil === PROFIL.INTERVENANT ? true : notAbleToChange}
                    requestPassId={requestPassId}
                    onOpenElemPatri={onOpenElemPatri}
                    deleteSection={deleteSection}
                    frameworkComponents={frameworkComponents}
                    agGridOptions={agGridOptions}
                    setAgGridOptions={setAgGridOptions}
                    createNewSection={createNewSection}
                    demandePassage={demandePassage}
                    reference={reference}
                    validSteps={validSteps}
                    onNextStep={onNextStep}
                    user={user}
                    isBuilding={isBuilding}
                    datePassage={datePassage}
                    setDatePassage={setDatePassage}
                />
            }
            {entries.some((entry) => entry.name === 'date_passage') &&
                <StepDatePassage
                    refs={refs}
                    profil={profil}
                    trajetDescr={trajetDescr}
                    demandePassageStyle={demandePassageStyle}
                    handleChange={handleChange}
                    handleChangeDate={handleChangeDate}
                    datePassage={datePassage}
                    setDatePassage={setDatePassage}
                    demandePassage={demandePassage}
                    validSteps={validSteps}
                    onNextStep={onNextStep}
                    reference={reference}
                    notAbleToChange={profil.profil === PROFIL.INTERVENANT ? true : notAbleToChange}
                />
            }
            {entries.some((entry) => entry.name === 'documents') &&
                <StepDocuments
                    refs={refs}
                    profil={profil}
                    onDropZoneAreaChange={onDropZoneAreaChange}
                    notAbleToChange={notAbleToChange}
                    renderDropZonePreview={renderDropZonePreview}
                    validSteps={validSteps}
                    onNextStep={onNextStep}
                    demandePassage={demandePassage}
                    caracConvoi={caracConvoi}
                    setDocuments={setDocuments}
                    documents={documents}
                    setAdminDocuments={setAdminDocuments}
                    adminDocuments={adminDocuments}
                    viewerIsOpen={viewerIsOpen}
                    setViewerIsOpen={setViewerIsOpen}
                    viewerFile={viewerFile}
                />
            }
            {entries.some((entry) => entry.name === 'engagement_et_validation_contrat') &&
                <StepEngagementValidationContrat
                    refs={refs}
                    profil={profil}
                    demandePassage={demandePassage}
                    setDemandePassage={setDemandePassage}
                    handleChangeCheckBox={handleChangeCheckBox}
                    validation={validation}
                    setValidation={setValidation}
                    notAbleToChange={profil.profil === PROFIL.INTERVENANT ? true : notAbleToChange}
                    demandePassageStyle={demandePassageStyle}
                    tracingDossier={tracingDossier}
                    setTracingDossier={setTracingDossier}
                    handleChangeDate={handleChangeDate}
                    requestPassId={requestPassId}
                    handleChange={handleChange}
                    validSteps={validSteps}
                    onRequestCompleted={onRequestCompleted}
                    reference={reference}
                />
            }
            {
                (entries.some((entry) => entry.name === 'informations_complementaires') && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.INTERVENANT)) &&
                <StepInformationsComplementaires
                    refs={refs}
                    profil={profil}
                    trajetDescr={trajetDescr}
                    complInfo={complInfo}
                    validation={validation}
                    setValidation={setValidation}
                    demandePassageStyle={demandePassageStyle}
                    handleChange={handleChange}
                    handleChangeDate={handleChangeDate}
                    validSteps={validSteps}
                    setValidSteps={setValidSteps}
                />
            }
            {
                (entries.some((entry) => entry.name === 'validation_des_intervenants') && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.INTERVENANT)) &&
                <StepValidationIntervenants
                    refs={refs}
                    profil={profil}
                    demandePassage={demandePassage}
                    setDemandePassage={setDemandePassage}
                    validationSaisies={validationSaisies}
                    setValidationSaisies={setValidationSaisies}
                    handleChangeCheckBox={handleChangeCheckBox}
                    notAbleToChange={notAbleToChange}
                    validSteps={validSteps}
                    setValidSteps={setValidSteps}
                    onNextStep={onNextStep}
                />
            }
            {
                (requestPassId !== 0 && entries.some((entry) => entry.name === 'tchat')) &&
                <StepTchat refs={refs} color={'#0094ca'} user={user} profil={profil} dossier={dossier} />
            }
        </>;
    };
    const modalLastEntry = () => {
        return (<>
            <div className={`modal-menu-entry no-action`} style={
                (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) ?
                    {
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        height: '165px',
                    }
                    :
                    {
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        height: 'fit-content',
                    }

            }
                key={adminEntries.length + 1}>
                <>
                    {requestPassId !== 0 && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) &&
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'row',
                            width: '100%',
                        }}>
                            <MySelect
                                labelClass={'select-label-black'}
                                name={'id_status'}
                                label={'Statut'}
                                disableClass={true}
                                style={{ minWidth: '260px' }}
                                displayLabel={true}
                                noNull={false}
                                datas={[
                                    {
                                        key: REQUEST_PASS_STATUS.NEW,
                                        value: 'Nouveau',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.ON_GOING,
                                        value: 'En cours',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.WAITING_CLIENT,
                                        value: 'En attente Client',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.WAITING_INTERN,
                                        value: 'En attente interne',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.BLOCKED,
                                        value: 'Bloqué',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.VALIDATED,
                                        value: 'Dossier Complet',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.SENT,
                                        value: 'Devis émis',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.SIGNED,
                                        value: 'Devis signé',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.ACCEPTED,
                                        value: 'Accord de principe émis',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.BILLED,
                                        value: 'Facturé',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.TERMINATED,
                                        value: 'Terminé',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.REFUSED,
                                        value: 'Refusé',
                                    },
                                    {
                                        key: REQUEST_PASS_STATUS.CANCELLED,
                                        value: 'Annulé',
                                    },
                                ]}
                                value={demandePassage.id_status}
                                handleChange={(e) => handleChange(e, demandePassage, setDemandePassage)}
                            />
                        </div>
                    }
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'row',
                            width: '100%',
                            justifyContent: 'space-evenly',
                            marginLeft: '4px',
                            flexWrap: 'wrap'
                        }}>
                            <MyButton onClick={handleClose} style={'buttonCloseModal'} label={'Fermer'} />
                            {
                                !notAbleToChange && (profil.profil === PROFIL.CLIENT) && requestPassId === 0 &&
                                <MyButton onClick={onRequestCompleted}
                                          style={((validation.isValidStep && tracingDossier.receptionDate) || tracingDossier.readAndSignedBy) ? 'buttonValidation' : 'buttonDisabled'}
                                          label={'Finaliser'}
                                          icon={faCheck}
                                />
                            }
                            {requestPassId !== 0 &&
                                <MyButton onClick={onRequestCompleted}
                                          style={(demandePassage.id_status === REQUEST_PASS_STATUS.ON_GOING || (demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_CLIENT || demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_INTERN) &&
                                              tracingDossier.description !== null && tracingDossier.description !== '' ||
                                              demandePassage.id_status === REQUEST_PASS_STATUS.BLOCKED && tracingDossier.description !== null && tracingDossier.description !== '' ||
                                              demandePassage.id_status === REQUEST_PASS_STATUS.VALIDATED ||
                                              demandePassage.id_status === REQUEST_PASS_STATUS.SENT ||
                                              demandePassage.id_status === REQUEST_PASS_STATUS.SIGNED ||
                                              demandePassage.id_status === REQUEST_PASS_STATUS.ACCEPTED ||
                                              demandePassage.id_status === REQUEST_PASS_STATUS.BILLED ||
                                              demandePassage.id_status === REQUEST_PASS_STATUS.TERMINATED ||
                                              demandePassage.id_status === REQUEST_PASS_STATUS.NEW ||
                                              demandePassage.id_status === REQUEST_PASS_STATUS.CANCELLED ||
                                              demandePassage.id_status === REQUEST_PASS_STATUS.REFUSED &&
                                              tracingDossier.description !== null && tracingDossier.description !== '') ? 'buttonValidation' : 'buttonDisabled'}
                                          label={'Enregistrer'}
                                          icon={faCheck}
                                />
                            }
                            {
                                (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) &&
                                <>
                                    {(requestPassId === 0 && demandePassage.id_status === REQUEST_PASS_STATUS.NEW) &&
                                        <MyButton onClick={onRequestCompleted}
                                                  style={(validation.isValidStep && tracingDossier.receptionDate !== null) ? 'buttonValidation' : 'buttonDisabled'}
                                                  label={'Finaliser'}
                                                  icon={faCheck}
                                        />
                                    }
                                </>
                            }
                        </div>
                </>

            </div>

            {!isBuilding && requestPassId !== 0 &&
                <div>
                    <ActionsRequestPassRenderer
                        data={buildRequestPass(false)}
                        fromRequestPass={true}
                    />
                </div>
            }

            {(profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) && requestPassId !== 0
                &&
                <div className={`modal-menu-entry no-action`}
                    style={{ height: '160px' }}
                >
                    {(demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_CLIENT
                        || demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_INTERN
                        || demandePassage.id_status === REQUEST_PASS_STATUS.BLOCKED
                        || demandePassage.id_status === REQUEST_PASS_STATUS.REFUSED) &&
                        <div style={{
                            width: '100%',
                        }}>
                            <TextField
                                label='Description du problème*'
                                type='text'
                                name='description'
                                value={tracingDossier.description || ''}
                                style={{ maxWidth: '87%', margin: '20px' }}
                                autoComplete='off'
                                fullWidth={true}
                                multiline
                                rows={4}
                                onChange={(e) => handleChange(e, tracingDossier, setTracingDossier)}
                                inputProps={{ maxLength: 255 }}
                            />
                        </div>
                    }

                    {Number(requestPassId) !== 0 && (Number(demandePassage.id_status) >= REQUEST_PASS_STATUS.VALIDATED) && (demandePassage.id_status !== REQUEST_PASS_STATUS.REFUSED) && validSteps.step9 &&
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                        }}>
                            <MyButton label='Devis/Facture' icon={faArrowRight} onClick={() => {
                                navigate(`/facturation?id=${demandePassage.id}`);
                            }} />
                            <MyButton label='Planification' icon={faArrowRight} onClick={() => {
                                navigate(`/planification?id=${demandePassage.id}&client=${complementIdentite.transporteur}`);
                            }} />
                        </div>
                    }
                </div>
            }
        </>
        );
    };

    // Méthode pour détecter un changement sur le dossier
    const detectChangeOnRequest = (requestPassData) => {
        let requestPassDataWithoutTracing = _.cloneDeep(requestPassData);
        let initialRequestPassWithoutMandataire = _.cloneDeep(initialRequestPass);

        delete requestPassDataWithoutTracing.tracingDossier.receptionDate;
        delete initialRequestPassWithoutMandataire.tracingDossier.receptionDate;

        requestPassDataWithoutTracing.complementIdentite.mandataire = requestPassDataWithoutTracing.representative;
        delete requestPassDataWithoutTracing.representative;
        requestPassDataWithoutTracing.complementIdentite.tiers = requestPassDataWithoutTracing.thirdParty;
        delete requestPassDataWithoutTracing.thirdParty;

        if (requestPassData.trajetDescr.descr.length > 1 || requestPassData.trajetDescr.descrRetour.length > 1) {
            return true;
        } else {
            const hasDescrChanged = !_.isEqual(requestPassData.trajetDescr.descr[0], initialDescr);
            const hasDescrRetourChanged = !_.isEqual(requestPassData.trajetDescr.descrRetour[0], initialDescrRetour);

            if (hasDescrChanged || hasDescrRetourChanged) {
                return true;
            } else {
                delete requestPassDataWithoutTracing.trajetDescr;
                delete initialRequestPassWithoutMandataire.trajetDescription;
                return !_.isEqual(requestPassDataWithoutTracing, initialRequestPassWithoutMandataire);
            }
        }

    };
    // endregion

    // region api

    // GATE-19 : acquisition du verrou d'édition
    const apiAcquireLock = () => {
        axios({
            method: 'POST',
            url: `${URL_API}/demande-passage/${requestPassId}/lock/acquire`,
            params: { userAction: user.user_id },
        })
            .then((response) => {
                lockTokenRef.current = response.data.lockToken;
                setLockToken(response.data.lockToken);
            })
            .catch((error) => {
                if (error.response && error.response.status === 423) {
                    setLockConflictModal(true);
                }
            });
    };

    // GATE-19 : libération du verrou (idempotente)
    const apiReleaseLock = () => {
        const token = lockTokenRef.current;
        if (!token || requestPassId === 0) return;
        lockTokenRef.current = null;
        setLockToken(null);
        axios({
            method: 'POST',
            url: `${URL_API}/demande-passage/${requestPassId}/lock/release`,
            params: { userAction: user.user_id, lockToken: token },
        }).catch(() => { });
    };

    const getRequestPass = () => {
        axios({
            method: 'GET', url: `${URL_API}/demande-passage/recuperer-demande`, params: {
                'id': requestPassId,
            },
        })
            .then((response) => {
                alert.removeAll();
                let requestPassData = response.data;

                if (requestPassData) {
                    setBuilding(true);
                    loadRequestPassIntoUI(requestPassData);
                }

            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.message);
            });
    };
    const getRequestPassDocuments = () => {
        axios({
            method: 'get', url: `${URL_API}/demande-passage/liste-documents-demande`, params: {
                id: duplicateRequestPassId !== 0 ? duplicateRequestPassId : requestPassId,
            },
        })
            .then((response) => {
                if (response.data.length > 0) {
                    // if its duplicate only get document with document_type = document
                    let files = response.data;

                    if (duplicateRequestPassId !== 0) {
                        files = files.filter((d) => (!d.documentType || d.documentType === DOCUMENT_TYPE.DOCUMENT));
                    }

                    setDocuments({
                        ...documents,
                        files: files.map(file => ({
                            ...file,
                            file: {
                                name: file.fileName,
                            },
                        })).filter((d) => (!d.documentType || d.documentType === DOCUMENT_TYPE.DOCUMENT)),
                    });
                    setAdminDocuments({
                        ...adminDocuments,
                        files: files.map(file => ({
                            ...file,
                            file: {
                                name: file.fileName,
                            },
                        })).filter((d) => (d.documentType === DOCUMENT_TYPE.DOCUMENT_ADMIN)),
                    });
                } else {
                    setDocuments({ ...documents, initialFiles: [] });
                    setAdminDocuments({ ...adminDocuments, initialFiles: [] });
                }
            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.message);
            });
    };

    const getDuplicateRequestPass = () => {
        axios({
            method: 'GET', url: `${URL_API}/demande-passage/dupliquer-demande`, params: {
                'id': duplicateRequestPassId,
            },
        })
            .then((response) => {
                alert.removeAll();
                let requestPassData = response.data;

                if (requestPassData.metadata.reference.typeDemande !== REQUEST_PASS_TYPE.SUPERIEUR) {
                    navigate('/demande-passage');
                }

                if (requestPassData) {
                    setBuilding(true);
                    loadRequestPassIntoUI(requestPassData);
                }

            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.message);
            });
    };

    const getBlacklistedUsers = () => {
        axios({
            method: 'get', url: `${URL_API}/blacklist/full-list`, params: { deleted: false },
        })
            .then((response) => {
                if (response.data.length > 0) {
                    let tab = [];
                    response.data.forEach((litige) => {
                        tab.push(litige.account.raison_sociale);
                    });
                    setBlacklistedUsersList(tab);
                }
            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.message);
            });
    };

    const apiGetNatureChargeOptions = () => {
        axios({
            method: 'get',
            url: `${URL_API}/parameters/get-by-key`,
            params: { key: PARAMETER.NAT_CONVOI },
        }).then((response) => {
            setNatureChargeOptions(response.data);
        }).catch((error) => {
            alert.removeAll();
            alert.error(error.message);
        });
    };

    const checkForChanges = (requestPass) => {
        let changes = {
            engagement: false,
            devisValidated: false,
            documentUploaded: false,
            planningFilled: false,
        };

        if (requestPass.id_status === REQUEST_PASS_STATUS.VALIDATED && dossier.id_status !== REQUEST_PASS_STATUS.VALIDATED) {
            changes.engagement = true;
        }

        if (requestPass.id_status === REQUEST_PASS_STATUS.SIGNED || (requestPass.id_status === REQUEST_PASS_STATUS.BILLED && dossier.id_status !== REQUEST_PASS_STATUS.BILLED)) {
            changes.devisValidated = true;
        }

        if (documents.files && documents.initialFiles) {
            if (documents.files.length !== documents.initialFiles.length) {
                changes.documentUploaded = true;
            }
        }

        if (adminDocuments.files && adminDocuments.initialFiles) {
            if (adminDocuments.files.length !== adminDocuments.initialFiles.length) {
                changes.documentUploaded = true;
            }
        }

        if (!changes.documentUploaded) {
            for (let i = 0; i < documents.files.length; i++) {
                if (documents.files[i].id !== documents.initialFiles[i].id) {
                    changes.documentUploaded = true;
                    break;
                }
            }
        }

        return changes;
    };

    const onRequestCompleted = () => {
        if (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) {
            if ((demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_CLIENT || demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_INTERN || demandePassage.id_status === REQUEST_PASS_STATUS.BLOCKED || demandePassage.id_status === REQUEST_PASS_STATUS.REFUSED) && (tracingDossier.description === '' || tracingDossier.description === null)) {
                (demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_CLIENT || demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_INTERN) ? alert.error('Vous devez renseigner les éléments manquants !') : alert.error('Vous devez renseigner la raison du blocage !');
                return;
            }
        }

        if (demandePassage.id_status === REQUEST_PASS_STATUS.NEW ||
            demandePassage.id_status === REQUEST_PASS_STATUS.ON_GOING ||
            demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_CLIENT ||
            demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_INTERN ||
            demandePassage.id_status === REQUEST_PASS_STATUS.BLOCKED) {
            for (let i = 0; i < 7; i++) {
                if (!checkRequestValues(i)) {
                    return;
                }
            }
        }

        setOverlayLoading(true);

        let requestPass = buildRequestPass();

        let changes = checkForChanges(requestPass);

        axios({
            method: 'POST',
            url: `${URL_API}/demande-passage/create-or-edit`,
            data: requestPass,
            params: { userAction: user.user_id, description: tracingDossier.description, duplicate: duplicateRequestPassId !== 0 ? duplicateRequestPassId : 0, lockToken: lockToken || undefined },
        })
            .then((response) => {
                alert.removeAll();
                alert.success('Le dossier a bien été enregistré !');

                if ((changes.engagement || changes.devisValidated || changes.documentUploaded || changes.planningFilled) && requestPass.id && requestPass.id !== 0 && profil.profil !== PROFIL.CLIENT) {
                    axios({
                        method: 'post',
                        url: URL_API + '/demande-passage/handle-changes',
                        data: changes,
                        params: { requestPassId: requestPass.id, userAction: user.user_id },
                    })
                        .then(() => {
                            alert.success('L\'email de notification a bien été envoyé !');
                        })
                        .catch((error) => {
                            alert.removeAll();
                            alert.error(error?.response?.data?.message || 'Une erreur est survenue, merci de contacter un administrateur');
                        });
                }

                // GATE-19 : libérer le verrou après sauvegarde réussie
                apiReleaseLock();

                window.localStorage.removeItem('requestPass');
                setOverlayLoading(false);
            })
            .catch((error) => {
                setOverlayLoading(false);
                alert.removeAll();
                alert.error(error.message);
            });

        if (requestPassId === 0) {
            clearRequestPass();
            navigate('/demande-passage');
        }
    };
    const apiListClientAccounts = () => {
        axios({
            method: 'GET',
            url: `${URL_API}/utilisateur/liste-client`,
            params: {
                userId: profil.profil === PROFIL.CLIENT ? user.user_id : null,
            },
        })
            .then((response) => {
                alert.removeAll();
                let data = response.data;
                let listClients = [];

                data.forEach(function (datum) {
                    listClients.push({
                        key: datum.user_id, label: datum.raison_sociale, value: datum.raison_sociale, data: datum,
                    });
                });

                setClients(listClients);
            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.message);
            });
    };
    const apiGetClientByTvaOrSiret = (value, forThirdParty = false, forSiret = false, forRepresentative = false) => {
        return new Promise((resolve, reject) => {
            if (!value) {
                reject(new Error('Aucune valeur n\'a été renseignée'));
            }

            let forThirdPartyUrl = `${URL_API}/billed-third-party/${forSiret ? 'get-by-siren-and-tva' : 'get-by-tva'}`;
            let forUserUrl = `${URL_API}/utilisateur/${forSiret ? 'recuperer-par-siret' : 'recuperer-par-tva'}`;

            if (thirdParty && forSiret) {
                if (!thirdParty.numTva) {
                    return;
                }
                value = thirdParty.numTva + '-' + value;
            }

            value = value.replace(/\s/g, '');

            axios({
                method: forThirdParty ? 'GET' : 'POST',
                url: forThirdParty ? forThirdPartyUrl : forUserUrl,
                params: {
                    value: String(value),
                },
            })
                .then((response) => {
                    alert.removeAll();

                    let data = response.data;

                    if (data?.account) {
                        let account = data.account;
                        let thirdParty = data.billedThirdParty;

                        if (forThirdParty) {
                            setThirdParty({
                                ...thirdParty,
                                numTva: thirdParty?.num_tva,
                                transporteur: thirdParty?.raison_sociale,
                                numSiren: thirdParty?.num_siren,
                                numSap: thirdParty?.num_sap,
                                numSapSubsidiary: thirdParty?.num_sap_subsidiary,
                                email: thirdParty?.email,
                                telephone1: thirdParty?.telephone1,
                                telephone2: thirdParty?.telephone2,
                            });

                            setClientHasSap(true);

                            if (!thirdParty.num_sap) {
                                setClientHasSap(false);
                            }

                        } else if (forRepresentative) {
                            setRepresentative({
                                ...representative,
                                transporteur: account.raison_sociale,
                                adresse: account.adresse,
                                complementAdresse: account.complement_adresse,
                                codePostal: account.code_postal,
                                commune: account.commune,
                                pays: account.pays,
                                email: account.email,
                                telephone1: account.telephone_1,
                                telephone2: account.telephone_2,
                                user_id: account.user_id,
                            });

                            setClientHasSap(true);

                            if (!account.num_sap) {
                                setClientHasSap(false);
                            }
                        } else {
                            setComplementIdentite({
                                ...complementIdentite,
                                transporteur: account.raison_sociale,
                                adresse: account.adresse,
                                numSiren: account.num_siren,
                                complementAdresse: account.complement_adresse,
                                codePostal: account.code_postal,
                                commune: account.commune,
                                pays: account.pays,
                                email: account.email,
                                telephone1: account.telephone1,
                                telephone2: account.telephone2,
                                user_id: account.user_id,
                            });

                            setClientHasSap(true);

                            if (!account.num_sap) {
                                setClientHasSap(false);
                            }

                        }

                    } else if (forThirdParty && data) {
                        setThirdParty({
                            ...thirdParty,
                            numTva: data?.num_tva,
                            transporteur: data?.raison_sociale,
                            numSiren: data?.num_siren,
                            numSap: data?.num_sap,
                            numSapSubsidiary: data?.num_sap_subsidiary,
                            email: data?.email,
                            telephone1: data?.telephone1,
                            telephone2: data?.telephone2,
                        });

                        setClientHasSap(true);

                        if (!data.num_sap) {
                            setClientHasSap(false);
                        }
                    } else {
                        setClientHasSap(false);
                    }

                    resolve(data);
                })
                .catch((error) => {
                    alert.removeAll();
                    alert.error(error.message);
                    reject(error);
                });
        });
    };

    const apiGetSapNumber = (value) => {
        if (!value) {
            return false;
        }

        axios({
            method: 'POST',
            url: `${URL_API}/demande-passage/get-client-sap-number`,
            params: {
                tvaNumber: value,
            },
        })
            .then((response) => {
                alert.removeAll();

                let data = response.data;

                if (data) {
                    setClientHasSap(true);
                    setThirdParty(prevState => ({
                        ...prevState,
                        numSap: data.num_sap,
                        numSapSubsidiary: data.num_sap_subsidiary,
                        numSiren: data.num_siren,
                        email: data.email,
                        telephone1: data.telephone1,
                        telephone2: data.telephone2,
                        transporteur: data.raison_sociale,
                    }));

                    if (!data.num_sap) {
                        setClientHasSap(false);
                    }

                } else
                    setClientHasSap(false);

            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.message);
            });
    };

    const apiListDepartments = () => {
        axios({
            method: 'GET',
            url: `${URL_API}/localisation/list-departements`,
        })
            .then((response) => {
                alert.removeAll();
                let departements = [];

                if (response.data && response.data.length > 0) {
                    response.data.map((departement) => {
                        departements.push(departement.departement);
                    });

                    setDepartments(departements);
                }

            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.message);
            });
    };

    const apiCancelRequest = async () => {
        setOverlayLoading(true);
        axios({
            method: 'POST',
            url: `${URL_API}/demande-passage/cancel-request`,
            params: { requestPassId: dossier.id },
        })
        .then((response) => {
            alert.removeAll();
            alert.success('Dossier annulé avec succès');
            setOverlayLoading(false);
        })
        .catch((error) => {
            logError(alert, error);
            setOverlayLoading(false);
        });
    };
    // endregion

    return (
        <>
            <MyModal
                fullscreen={true}
                title={requestPassId === 0 ? 'création d\'un dossier' : 'édition d\'un dossier'}
                additionalTitle={requestPassId !== 0 ? 'N° ' + requestPassId : ''}
                urlCloseModal='/demande-passage'
                entries={entries}
                additionalEntry={modalLastEntry()}
                loading={false}
                overlayLoading={overlayLoading}
                refs={refs}
                props={props}
                content={getContent()}
                data={getDemandePassageDatas()}
                entryPointReadUntil={numberActiveStep}
                validSteps={validSteps}
            />
            <MyDialog
                open={openConfirmationModal}
                handleClose={setOpenConfirmationModal}
                title='Voulez-vous vraiment fermer cette page ?'
                content={'Certaines données non-sauvegardées pourraient être perdues'}
                dialog={onConfirmationModalClose}
            />
            <MyDialog
                open={openAlertModal}
                handleClose={setOpenAlertModal}
                title={null}
                content={'Le convoi fait moins de 48 tonnes en charge: la demande de passage n\'est pas obligatoire'}
                dialog={() => (setOpenAlertModal(false))}
            />
            <MyDialog
                open={lockConflictModal}
                handleClose={setLockConflictModal}
                title={null}
                content={"Attention : Ce dossier est en cours de modification par un autre utilisateur.\nIl est temporairement verrouillé. Il sera bientôt disponible à l'édition."}
                dialog={() => navigate('/demande-passage')}
                hideCloseBtn={true}
                trueButtonLabel="OK"
            />
            <MyDialog
                open={openCancellationModal}
                handleClose={setOpenCancellationModal}
                title='Voulez-vous vraiment annuler cette demande ?'
                content={'Un message sera envoyé aux gestionnaires'}
                dialog={onCancelModalClose}
            />
        </>
    );
};

export default React.memo(DemandePassage);
